import CustomerGrid from "./customerGrid";

export default CustomerGrid;